export default __webpack_public_path__ + "static/media/q9_step1_3.659cd5a5.png";